module.exports = __webpack_public_path__ + "img/vue-mk-header.3f788d05.jpg";